<template>
  <div class="background" v-if="appTheme.theme" v-loading="loading">
    <div class="wrap">
      <div class="logo">
        <div v-if="appTheme.theme.banner" style="display: flex;align-items: center;">
          <el-image
            style="width: 200px; height: 30px"
            :src="appTheme.theme.banner"
            fit="cover"
          ></el-image>
        </div>
        <div :style="'color:'+appTheme.theme.themeColor">
          <h5>{{ language("register.title") }}</h5>
          <!-- <span
            > {{ language("register.subTitle[0]") }}</br>
          {{ language("register.subTitle[1]") }}{{ appTheme.theme.title
            }}{{ language("register.subTitle[2]") }}</span
          > -->
          <span v-html="languageTC('register.subTitle',appTheme.theme.title)"></span>
        </div>
      </div>
      <div class="wrap_content">
        <div class="title_wrap">
          <h3>{{ language("userInfo.title1") }}</h3>
        </div>
        <div class="user_data">
          <el-form
            :model="form"
            :rules="rules"
            ref="userInfoForm"
            class="form"
            size="small"
            label-position="left"
            label-width="150px"
          >
               <el-form-item
              prop="password"
              :label="language('userInfo.formLabel[10]')"
            >
              <span class="status">{{memberInfo.memberNum}}</span>
            </el-form-item>
            <el-form-item
              prop="headimgurl"
              :label="language('userInfo.formLabel[9]')"
            >
              <div class="user_img_wrap" :key="new Date().getTime()">
                <el-image
                  class="user_img"
                  :src="form.headimgurl + '?w=200'"
                  fit="cover"
                  v-if="form.id"
                >
                  <div slot="error" class="image-slot">
                    <img :src="userImg" class="user_img" />
                  </div>
                </el-image>
                   <el-image
                  class="user_img"
                  :src="form.headimgurl + '?w=200'"
                  fit="cover"
                  v-else
                >
                  <div slot="error" class="image-slot">
                    <img :src="userImg" class="user_img" />
                  </div>
                </el-image>
                <el-button type="primary" plain class="add_btn">
                  {{ language("userInfo.userImgButton") }}
                  <input
                    type="file"
                    id="inputImage"
                    name="file"
                    @change="tirggerFile($event)"
                    accept="image/gif, image/jpg, image/jpeg, image/bmp, image/png"
                  />
                </el-button>
              </div>
            </el-form-item>
            <el-form-item
              prop="userName"
              :label="language('userInfo.formLabel[0]')"
            >
              <!-- <span>{{ userInfo.userName }}</span> -->
              <el-input
                v-model="form.userName"
                style="width: 200px"
                :placeholder="language('userInfo.placeholder[1]')"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="nickname"
              :label="language('userInfo.formLabel[1]')"
            >
              <!-- <span>{{ userInfo.nickname }}</span> -->
              <el-input
                v-model="form.nickname"
                style="width: 200px"
                :placeholder="language('userInfo.placeholder[2]')"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="password"
              :label="language('userInfo.formLabel[2]')"
            >
              <el-button plain size="small" @click="forgetPassword">{{
                language("userInfo.alter")
              }}</el-button>
            </el-form-item>
            <el-form-item prop="sex" :label="language('userInfo.formLabel[3]')">
              <el-radio v-model="form.sex" :label="1">{{
                language("userInfo.gender[0]")
              }}</el-radio>
              <el-radio v-model="form.sex" :label="2">{{
                language("userInfo.gender[1]")
              }}</el-radio>
            </el-form-item>
            <el-form-item
              prop="password"
              :label="language('userInfo.formLabel[4]')"
            >
              <span class="bind" v-if="userInfo.phone">{{ userInfo.phone }}</span>
              <el-button plain size="small" @click="changePhone" >
                <template v-if="phoneVerified == 1 && locale_lang=='zh-HK'" >
                  <span v-if="userInfo.phone">{{
                    language("userInfo.change")
                  }}</span>
                  <span v-else-if="!userInfo.phone">{{
                    language("userInfo.bind")
                  }}</span>
                  <span>{{ language("userInfo.phone") }}</span>
                </template>
                <template v-if="phoneVerified == 0 && locale_lang=='zh-HK'">
                  <span v-if="userInfo.phone">{{
                    language("userInfo.unvalidated")
                  }}</span>
                  <template v-else>
                    <span>{{ language("userInfo.bind") }}</span>
                    <span>{{ language("userInfo.phone") }}</span>
                  </template>
                </template>

                <template v-if="phoneVerified == 1 && locale_lang=='en'" >
                  <span v-if="userInfo.phone">{{
                    language("userInfo.change")
                  }}</span>
                  <span v-else-if="!userInfo.phone">{{
                    language("userInfo.bind")
                  }}</span>
                  <span> {{ language("userInfo.phone") }}</span>
                </template>
                <template v-if="phoneVerified == 0 && locale_lang=='en'">
                  <span v-if="userInfo.phone">{{
                    language("userInfo.unvalidated")
                  }}</span>
                  <template v-else>
                    <span>{{ language("userInfo.bind") }}</span>
                    <span> {{ language("userInfo.phone") }}</span>
                  </template>
                </template>
      
              </el-button>
            </el-form-item>
            <el-form-item :label="language('userInfo.formLabel[5]')">
              <span class="bind" v-if="userInfo.email">{{ userInfo.email }}</span>
              <el-button plain size="small" @click="changeEmail" >
                <!-- <span v-if="userInfo.email && emailVerified == 1">{{
                  language("userInfo.change")
                }}</span>
                <span v-if="!userInfo.email && emailVerified == 1">{{
                  language("userInfo.bind")
                }}</span>
                <span v-if="emailVerified == 1 || userInfo.email == ''">{{
                  language("userInfo.email")
                }}</span>
                <span v-if="emailVerified == 0 && userInfo.email">{{
                  language("userInfo.unvalidated")
                }}</span> -->


                <template v-if="emailVerified == 1 && locale_lang=='zh-HK'">
                  <span v-if="userInfo.email">{{
                    language("userInfo.change")
                  }}</span>
                  <span v-else-if="!userInfo.email">{{
                    language("userInfo.bind")
                  }}</span>
                  <span>{{ language("userInfo.email") }}</span>
                </template>
                <template v-if="emailVerified == 0 && locale_lang=='zh-HK'" >
                  <span v-if="userInfo.email">{{
                    language("userInfo.unvalidated")
                  }}</span>
                  <template v-else>
                    <span>{{ language("userInfo.bind") }}</span>
                    <span>{{ language("userInfo.email") }}</span>
                  </template>
                </template>

                <template v-if="emailVerified == 1 && locale_lang=='en'">
                  <span v-if="userInfo.email">{{
                    language("userInfo.change")
                  }}</span>
                  <span v-else-if="!userInfo.email">{{
                    language("userInfo.bind")
                  }}</span>
                  <span> {{ language("userInfo.email") }}</span>
                </template>

                <template v-if="emailVerified == 0 && locale_lang=='en'">
                  <span v-if="userInfo.email">{{
                    language("userInfo.unvalidated")
                  }}</span>
                  <template v-else>
                    <span>{{ language("userInfo.bind") }}</span>
                    <span> {{ language("userInfo.email") }}</span>
                  </template>
                </template> 



              </el-button>
            </el-form-item>
            <el-form-item
              prop="birthday"
              :label="language('userInfo.formLabel[6]')"
            >
              <template v-if="userInfo.birthday">
                <span>{{ form.birthday }}</span>
                <span class="birthday">{{
                  language("userInfo.placeholder[3]")
                }}</span>
              </template>
              <template v-if="!userInfo.birthday">
                <el-date-picker
                  v-model="form.birthday"
                  type="month"
                  :placeholder="language('userInfo.placeholder[4]')"
                  :picker-options="pickerOptions"
                  :default-value="defaultValue"
                  :value-format="'yyyy-MM'"
                style="width: 250px"

                >
                </el-date-picker>
              </template>
            </el-form-item>
            <el-form-item
              prop="password"
              :label="language('userInfo.formLabel[7]')"
            >
              <el-input
                v-model="form.extraData.address"
                style="width: 250px"
                :placeholder="language('userInfo.placeholder[0]')"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="password"
              :label="language('userInfo.formLabel[8]')"
            >
              <span class="status">{{ language('userData.tipsText17') }}</span>
              <span class="status red" v-if="memberInfo.hasDeleteAccount == 1"
                >{{ language('userData.tipsText18') }}</span
              >
              <el-button plain size="small" @click="openDisableAccount">{{
                language("userInfo.stopButton")
              }}</el-button>
            </el-form-item>
          
          </el-form>
          <div class="button">
            <el-button
              type="primary"
              @click="save"
              v-if="JSON.stringify(form) != JSON.stringify(form2)"
              >{{ language("register.save") }}</el-button
            >
          </div>
        </div>

        
        <otherUserData @loading="saveLoading" @success="success"></otherUserData>

        <template v-if="sdkInfo && (sdkInfo.facebook || sdkInfo.google)">
          <div class="webWapBindOauth">
            <div class="title_wrap">
              <h3>{{ language('userInfo.serveTips6') }}</h3>
            </div>
            <div>
              <el-form
                status-icon
                class="form"
                size="small"
                label-position="left"
                label-width="150px"
              >
                <el-form-item :label="'Facebook'" v-if="sdkInfo.facebook">
                  <div v-show="!accountList['Facebook']">
                    <el-button plain size="small" id="Facebook-signin-button"
                      >{{ language("userData.tipsText57") }}</el-button
                    >
                  </div>
                  <div v-show="accountList['Facebook']">
                    <el-button
                      plain
                      size="small"
                      @click="unbindOauth('Facebook')"
                      >{{ language("userData.tipsText56") }}</el-button
                    >
                  </div>
                </el-form-item>
                <el-form-item :label="'Google'" v-if="sdkInfo.google">
                  <div v-show="!accountList['Google']">
                    <el-button plain size="small" id="Google-signin-button"
                      >{{ language("userData.tipsText57") }}</el-button
                    >
                  </div>
                  <div v-show="accountList['Google']">
                    <el-button plain size="small" @click="unbindOauth('Google')"
                      >{{ language("userData.tipsText56") }}</el-button
                    >
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </template>
        <div class="title_wrap">
          <h3>{{ language("userInfo.title2") }}</h3>
        </div>
        <div class="serve_li_wrap">
          <div class="serve_li_title_back">
            <div class="serve_li_title">
              <div class="li_1"></div>
              <div class="li_2">{{ language("userInfo.serveStatus") }}</div>
              <div class="li_3">{{ language("userInfo.serveEmail") }}</div>
              <div class="li_4">{{ language("userInfo.serveRules1") }}</div>
            </div>
          </div>

          <div class="serve_li" v-for="(itmes, index) in list" :key="index">
            <div class="li_1" @click="clickLogo(itmes)">
              <div>
                <el-image
                  style="width: 50px; height: 50px"
                  :src="itmes.logo"
                  fit="cover"
                  class="merchant_list_img"
                ></el-image>
                <p class="serve_tips">
                  {{ itmes.name
                  }}<i
                    class="el-icon-warning name_tips"
                    :style="'color:' + appTheme.theme.themeColor"
                  ></i>
                </p>
              </div>
            </div>
            <div class="li_2">
              <div v-if="itmes.status == 1">
                <p>{{ language("userInfo.openServe") }}</p>
                <!-- <el-button
                class="w98"
                  plain
                  size="small"
                  :disabled="itmes.allowCancelBiz == 0 ? true : false"
                  @click="openAndStopServe(0, itmes.code, itmes.bsKey)"
                  >{{ language("userInfo.stopButton2") }}</el-button
                > -->
                    <el-button
                class="w98"
                  plain
                  size="small"
                  
                  @click="openContact(itmes)"
                  >{{ language("userInfo.stopButton2") }}</el-button
                >
              </div>
              <div v-if="itmes.status == 0">
                <p>{{ language("userInfo.closeServe") }}</p>
                <el-button
                class="w98"
                  plain
                  size="small"
                  :disabled="itmes.allowCancelBiz == 0 ? true : false"
                  @click="openAndStopServe(1, itmes.code, itmes.bsKey)"
                  >{{ language("userInfo.openButton") }}</el-button
                >
              </div>
            </div>
            <div class="li_3">
              <el-switch
                v-if="itmes.status == 1"
                v-model="itmes.isAgreePush"
                :active-text="language('userInfo.open')"
                :inactive-text="language('userInfo.close')"
                @change="changeAgreePush($event, itmes)"
                :active-value="1"
                :inactive-value="0"
              >
              </el-switch>
              <div v-if="itmes.status == 0">{{ language("userServe.tipsText13") }}</div>
            </div>
            <div class="li_4">
              <div>
                <p>
                  <el-link :underline="false" @click="openTermsText(itmes)">{{
                    language("userInfo.serveRules3")
                  }}</el-link>
                </p>
                <p>
                  <el-link :underline="false" @click="openPrivacyText(itmes)">{{
                    language("userInfo.serveRules2")
                  }}</el-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="language('register.forgetPassword')"
      :visible.sync="updataPasswordDialog"
      width="40%"
      append-to-body
      :close-on-click-modal="false"
    >
      <template v-if="updataPasswordDialog">
        <updataPassword></updataPassword>
      </template>
    </el-dialog>

    <el-dialog
      :title="language('register.disableAccount')"
      :visible.sync="disableAccountDialog"
      width="50%"
      append-to-body
      :close-on-click-modal="false"
    >
      <template v-if="disableAccountDialog">
        <disableAccount></disableAccount>
      </template>
    </el-dialog>

    <el-dialog
      :title="
        (userInfo.phone
          ? language('userInfo.change')
          : language('userInfo.bind')) 
      "
      :visible.sync="changePhoneDialog"
      :width="'50%'"
      append-to-body
      :close-on-click-modal="false"
    >
      <template v-if="changePhoneDialog">
        <changePhone @updateUserInfo="updateUserInfo"></changePhone>
      </template>
    </el-dialog>

    <el-dialog
      :title="
        (userInfo.phone
          ? language('userInfo.change')
          : language('userInfo.bind'))
      "
      :visible.sync="changeEmailDialog"
      width="50%"
      append-to-body
      :close-on-click-modal="false"
    >
      <template v-if="changeEmailDialog">
        <changeEmail @updateUserInfo="updateUserInfo"></changeEmail>
      </template>
    </el-dialog>

    <el-dialog
      :title="language('register.tipsText17')"
      :visible.sync="showAPPExplain"
      width="50%"
      append-to-body
      :close-on-click-modal="false"
    >
      <div v-html="appSummary" class="app_explain_button"></div>
    </el-dialog>

    <el-dialog
      :title="language('userInfo.title2')"
      :visible.sync="showContact"
      width="50%"
      append-to-body
      :close-on-click-modal="false"
    >
      <div  class="app_explain_button app_explain_button2">
          <div>{{ language('userInfo.serveTips4') }}</div>
          <div>{{ language('userInfo.serveTips5') }}：{{contact}}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import updataPassword from "../components/updataPassword.vue";
import disableAccount from "../components/disableAccount.vue";
import changePhone from "../components/changePhone.vue";
import changeEmail from "../components/changeEmail.vue";
import otherUserData from "../components/otherUserData.vue";
import Dator from "../utils/censor.js";
const webWapBindOauthMini = require("../packages/webWapBindOauth").mixin;

let OSS = require("ali-oss");
export default {
  components: {
    updataPassword,
    disableAccount,
    changePhone,
    changeEmail,
    otherUserData,
  },
  mixins: [webWapBindOauthMini],
  data() {
    return {
      form: {
        sex: "",
        nickname: "",
        userName: "",
        extraData: { address: "" },
        birthday: "",
        headimgurl: "",
      },
      form2: {},
      rules: {
        nickname: [
          { required: true, validator: this.checkNickname, trigger: "blur" },
        ],
        userName: [
          { required: true, validator: this.checkUserName, trigger: "blur" },
        ],
        headimgurl: [
          { required: true, message:  this.language('userInfo.serveTips7'), trigger: "blur" },
        ],
        sex: [{ required: true, message:   this.language('userData.tipsText62'), trigger: "blur" }],
        birthday: [{ required: true, message:  this.language('userInfo.placeholder[4]'), trigger: "blur" }],
      },
      switchValue: "",
      userInfo: {},
      memberInfo: {},
      updataPasswordDialog: false,
      disableAccountDialog: false,
      list: [],
      changeEmailDialog: false,
      changePhoneDialog: false,
      emailVerified: 1,
      phoneVerified: 1,
      pickerOptions: {
        disabledDate(time) {
          var date = new Date();
          var year = date.getFullYear() - 18;
          var month = date.getMonth();
          if (month == 0) {
            month = 12;
          }
          var day = new Date(year, month, 0).getDate(); //拿取18年前的前一个月的那个月有多少天
          return time.getTime() > new Date(`${year}/${month}/${day}`).getTime();
        },
      },
      defaultValue: "",
      userImg: require("@/assets/user.png"),
      loading: false,
      appSummary: "",
      showAPPExplain: false,
      contact: "",
      showContact: false,
    };
  },
  watch: {
    ssoSDK: {
      handler(o, n) {
        if (this.ssoSDK) {
          this.getUser();
          this.getdefaultValue();
          this.getOauthList();
        }
      },
      deep: true,
      immediate: true,
    },
    appTheme: {
      handler(o, n) {
        if (
          this.appTheme.theme &&
          (this.appTheme.theme.facebookAppId ||
            this.appTheme.theme.googleClientId)
        ) {
          let obj = {
            Facebook: {
              appId: this.appTheme.theme.facebookAppId,
              btnId: "Facebook-signin-button",
            },
            Google: {
              client_id: this.appTheme.theme.googleClientId,
              btnId: "Google-signin-button",
            },
            bindOauth: true,
            callback: (d) => {
              this.bindWebWapOauth(d)
                .then(() => {
                  this.getOauthList();
                })
                .catch(() => {});
            },
          };
          this.initWebWapOauth(obj);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    appTheme: function () {
      return this.$store.state.appData.appTheme;
    },
    ssoSDK: function () {
      return this.$store.state.appData.ssoSDK;
    },
    sdkInfo: function () {
      return this.$store.state.appData.sdkInfo;
    },
  },
  methods: {
    checkNickname(rule, value, callback) {
      let dator = new Dator.Dator();

      if (value) {
        dator.add(value, [
          {
            strategy: "checkStringFormat:2:4",
            errMsg: this.language("userInfo.datorErrText[1]"),
          },
          {
            strategy: "checkStringFormat:25:2",
            errMsg: this.language("userInfo.datorErrText[5]"),
          },
          {
            strategy: "checkNickName",
            errMsg: this.language("userInfo.datorErrText[7]"),
          },
        ]);
      }
      if (!value) {
        callback(new Error(this.language("userInfo.datorErrText[1]")));
      }
      if (dator.getErrmsg()) {
        callback(new Error(dator.getErrmsg()));
      } else {
        callback();
      }
    },
    checkUserName(rule, value, callback) {
      let dator = new Dator.Dator();

      var re = /^[0-9]+$/;
      let ut = value.split("");
      var flag = false;
      var text = "";
      ut.forEach((v) => {
        if (re.test(v)) {
          flag = true;
          text = this.language("userInfo.datorErrText[6]");
        }
      });
      if (this.form.userName) {
        dator.add(this.form.userName, [
          {
            strategy: "checkStringFormat:2:4",
            errMsg: this.language("userInfo.datorErrText[1]"),
          },
          {
            strategy: "checkStringFormat:25:2",
            errMsg: this.language("userInfo.datorErrText[5]"),
          },
          // {
          //   strategy: "checkName",
          //   errMsg: this.language("userInfo.datorErrText[4]"),
          // },
          {
            strategy: "checkUserName",
            errMsg: this.language("userInfo.datorErrText[6]"),
          },
        ]);
      }
      if (!this.form.userName) {
        callback(new Error(this.language("userInfo.datorErrText[1]")));
      } else if (flag) {
        callback(new Error(text));
      } else if (dator.getErrmsg()) {
        callback(new Error(dator.getErrmsg()));
      } else {
        callback();
      }
    },
    getUser() {
      oauthSDK
        .getUserInfo()
        .then((e) => {
          this.loading = false;
          this.emailVerified = e.emailVerified;
          this.phoneVerified = e.phoneVerified;
          this.userInfo = e;
          if (e.sex == 1 || e.sex == 2) {
            this.form.sex = e.sex;
          }
          this.form.nickname = e.nickname;
          this.form.userName = e.userName;
          this.form.birthday = e.birthday;
          this.form.headimgurl = e.headimgurl;
          if (e.extraData) {
            this.form.extraData.address = e.extraData.address;
          }
          this.form2 = JSON.parse(JSON.stringify(this.form));
          oauthSDK
            .getMemebrInfo()
            .then((e) => {
              this.memberInfo = e;
            })
            .catch((err) => {
              console.log(err);
              this.user401(err);
              // if (err.code == 401) {
              //   this.goToPage({ url: "login", query: {} });
              // }
            });
        })
        .catch((err) => {
          this.loading = false;
          this.user401(err);
          console.log(err);
        });

      this.getServiceList();
    },
    getServiceList() {
      oauthSDK
        .getServiceList()
        .then((e) => {
          this.list = e;
        })
        .catch((err) => {
          this.user401(err);
          console.log(err);
        });
    },
    tirggerFile(event) {
      let files = event.target.files[0];
      let userInfo = this.userInfo;
      let photoName = +userInfo.id + "/" + new Date().getTime();
      let photoType = files.name.split(".")[1];
      let name = "profile/" + photoName + "." + photoType;
      this.uploadImg(name, files);
    },
    uploadImg(photoName, files) {
      // this.defalutToast("頭像上傳中");
      this.loading = true;
      let postD = {
        fileName: photoName,
      };
      oauthSDK
        .uploadToken(postD)
        .then((res) => {
          let client = new OSS({
            accessKeyId: res.accessKeyId,
            accessKeySecret: res.accessKeySecret,
            bucket: process.env.VUE_APP_OSS_BUCKET,
            stsToken: res.securityToken,
            endpoint: process.env.VUE_APP_ENDPOINT,
            secure: true,
          });
          var tempCheckpoint = "";
          try {
            client
              .multipartUpload(photoName, files, {
                progress: async function (p, checkpoint) {
                  tempCheckpoint = checkpoint;
                },
                mime: "image/jpeg",
              })
              .then((ossRes) => {
                this.loading = false;
                this.form.headimgurl =
                  ossRes.res.requestUrls[0].split("?uploadId")[0];
              })
              .catch((err) => {
                this.loading = false;
                this.defalutToast( err);
                this.user401(err);
              });
          } catch (error) {
            this.loading = false;
            this.defalutToast( err);
            this.user401(err);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.defalutToast( err);
          this.user401(err);
        });
    },
    save() {
      //校验数字

      this.$refs["userInfoForm"].validate((valid) => {
        if (valid) {
          let data = {
            extraData: JSON.stringify({
              address: this.form.extraData.address,
            }),
            sex: this.form.sex,
            nickname: this.form.nickname,
            userName: this.form.userName,
            birthday: this.form.birthday,
            headimgurl: this.form.headimgurl,
          };
          this.loading = true;
          oauthSDK
            .updateInfo(data)
            .then((e) => {
              // this.$message({
              //   message: this.language("userInfo.operationSuccess"),
              //   type: "success",
              // });
              this.defalutToast(
                this.language("userInfo.operationSuccess"),
                "success"
              );
              this.form = {
                sex: "",
                nickname: "",
                userName: "",
                extraData: { address: "" },
                birthday: "",
                headimgurl: "",
              };
              this.form2 = {
                sex: "",
                nickname: "",
                userName: "",
                extraData: { address: "" },
                birthday: "",
                headimgurl: "",
              };
              this.getUser();
              this.getdefaultValue();
              this.getOauthList();
            })
            .catch((err) => {
              this.loading = false;
              this.defalutToast(err.message);
              this.user401(err);
              console.log(err);
            });
        } else {
          console.log("error submit!!", this.form);
          this.defalutToast(this.language('userInfo.serveTips8'));
          return false;
        }
      });
    },
    forgetPassword() {
      this.updataPasswordDialog = true;
    },
    openDisableAccount() {
      this.disableAccountDialog = true;
    },
    changeAgreePush(e, items) {
      let data = {
        // memberId: this.memberInfo.id,
        // accountId: this.memberInfo.userId,
        code: items.code,
        pushStatus: items.isAgreePush,
      };
      oauthSDK
        .closeEmailService(data)
        .then((e) => {
          this.$message.success(this.language("userInfo.operationSuccess"));
          this.getServiceList();
        })
        .catch((err) => {
          this.user401(err);
          this.defalutToast(err.message);
        });
    },
    openTermsText(item) {
      window.open(item.termsUrl);
    },
    openPrivacyText(e) {
      window.open(e.privacyUrl);
    },
    clickLogo(e) {
      this.appSummary = e.introText;
      this.showAPPExplain = true;
    },
    openAndStopServe(n, code, bsKey) {
      let text = "";
      //關閉當前服務文案
      if (bsKey == this.$urlData.bsKey && n == 0) {
        text = this.language("userInfo.serveTips3");
      } else {
        text =
          n == 0
            ? this.language("userInfo.serveTips")
            : this.language("userInfo.serveTips2");
      }
      this.$confirm(text,this.language("ui.tipsTitle"), {
        confirmButtonText:  this.language("form.confirmBtn"),
        cancelButtonText:  this.language("form.cancelBtn"),
        type: "warning",
      })
        .then(() => {
          let data = [{ openStatus: n, code: code }];
          let queryText = "";
          oauthSDK
            .closeService(data, queryText)
            .then((e) => {
              this.$message.success(this.language("userInfo.operationSuccess"));
              if (bsKey == this.$urlData.bsKey && n == 0) {
                setTimeout(() => {
                  this.replacePage({ url: this.$urlData.logoutURL, query: {} });
                }, 1000);
              } else {
                this.getServiceList();
              }
            })
            .catch((err) => {
              this.user401(err);
              this.defalutToast(err.message);
            });
        })
        .catch(() => {});
    },
    changeEmail() {
      this.changeEmailDialog = true;
    },
    changePhone() {
      this.changePhoneDialog = true;
    },
    updateUserInfo() {
      this.getUser();
      this.changeEmailDialog = false;
      this.changePhoneDialog = false;
    },
    getdefaultValue() {
      var date = new Date();
      var year = date.getFullYear() - 18;
      var month = date.getMonth();
      if (month == 0) {
        month = 12;
      }
      var day = new Date(year, month, 0).getDate(); //拿取18年前的前一个月的那个月有多少天
      this.defaultValue = new Date(`${year}/${month}/${day}`).getTime();
    },
    openContact(e) {
      this.contact = e.contact;
      this.showContact = true;
    },
    saveLoading(loading) {
      this.loading = loading;
    },
    success() {
      this.loading = false;
      this.updateUserInfo();
    },
  },
};
</script>
<style>
.el-form-item__label {
  font-weight: bold;
}
</style>
<style lang="scss" scoped>
.background {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  padding-bottom: 50px;
}
.wrap {
  width: 850px;
  border: 1px solid #bbbbbb;
  margin: 50px auto 0 auto;
  padding: 34px 0 34px 0;
}
.logo {
  display: flex;
  width: 570px;
  margin: 0 auto;
  justify-content: center;
  h5 {
    font-size: 18px;
    margin-left: 24px;
  }
  span {
    margin-top: 10px;
    display: block;
    margin-left: 24px;
    color: rgba(16, 16, 16, 1);
    font-size: 14px;
    // width: 230px;
  }
}
.wrap_content {
  width: 92%;
  margin: 0 auto;
  color: #101010;
}
.title_wrap {
  border-bottom: 1px solid #bbbbbb;
  padding: 0 0 10px 0;
  margin-bottom: 20px;
  h3 {
    font-size: 18px;
  }
}
.status {
  margin-right: 20px;
}
.user_data {
  margin-bottom: 60px;
}
.serve_li_title_back {
  width: 100%;
  background: #fff;
}
.serve_li_title {
  display: flex;
  font-size: 14px;
  font-weight: bold;
  padding-bottom: 10px;
  margin: 0 auto;
  width: 95%;
}
.serve_li_wrap {
  background: #fbfbfb;
}
.serve_li {
  display: flex;
  padding: 10px 0;
  width: 95%;
  margin: 0 auto;
  border-bottom: 1px solid #bbbbbb;
  font-size: 14px;
}
.li_1 {
  width: 25%;
  display: flex;
  cursor: pointer;
  //   justify-content: center;
}
.li_2 {
  width: 25%;
  display: flex;
  justify-content: center;
  p {
    margin-bottom: 10px;
    text-align: center;
  }
}
.li_3 {
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.li_4 {
  width: 25%;
  display: flex;
  justify-content: center;
  // align-items: center;
  p {
    text-align: center;
    margin-bottom: 10px;
  }
}
.serve_li_wrap .serve_li:last-child {
  border-bottom: none;
}
.button {
  display: flex;
  justify-content: center;
}
.merchant_list_img {
  // border: 1px solid #c5c5c5c5;
}
.bind {
  margin-right: 10px;
}
.birthday {
  margin-left: 10px;
  color: rgba(0, 0, 0, 0.85);
}
.user_img_wrap {
  display: flex;
  align-items: center;
}
.user_img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 30px;
}
.add_btn {
  position: relative;
}
#inputImage {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.red {
  color: red;
}
.webWapBindOauth {
  margin-bottom: 80px;
}
.name_tips {
  margin: 5px;
}
.app_explain_button {
  white-space: pre-wrap;
}
.w98 {
  // width: 98px;
}
.app_explain_button2 {
  div {
    margin-bottom: 10px;
  }
}
</style>